import moment from 'moment-timezone';
let momentInstance = moment.tz.setDefault('Africa/Nairobi');
export default momentInstance;